<template>
  <div class="payment-mode pb-10">
    <p class="form-title">Ticket Information</p>

    <div class="form-item">
      <span class="form-item-label"> Ticket price range: </span>
      <BKInput
        v-model="priceRange"
        outlined
        placeholder="e.g., $10 - $50, from $20"
      />
    </div>

    <div class="form-item">
      <span class="form-item-label"> Payment URL: </span>
      <BKInput
        v-model="paymentUrl"
        type="url"
        outlined
        placeholder="https://yourpaymentlink.com"
      />
    </div>

    <EventEditActionButtons
      :is-loading="isPending"
      :disabled="false"
      :error="error?.message"
      @next="handleNext"
      @back="$emit('back')"
      @cancel="handleCancel"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import { IEventEdit } from '@/enitites/event'
import BKInput from '@/components/AppShared/BKInput.vue'
import { ISetPaymentSystemPayloadDisabled } from '@/modules/Payment/types'
import { useSetPaymentSystem } from '@/modules/Payment/api/queries'

const { mutate: setPaymentSystem, isPending, error } = useSetPaymentSystem()

const props = defineProps<{
  eventData: IEventEdit
}>()

const emit = defineEmits<{
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}>()

const priceRange = ref<string | undefined>(props.eventData.paymentSystem?.priceRange)
const paymentUrl = ref<string>(props.eventData.paymentSystem?.purchaseTicketsExternalUrl || '')

function saveEventData(onSuccess: () => void) {
  if (isPending.value) return

  const payload: ISetPaymentSystemPayloadDisabled = {
    isEnabled: false,
    priceRange: priceRange.value || 'Not specified',
    purchaseTicketsExternalUrl: paymentUrl.value,
  }

  setPaymentSystem(
    {
      eventId: props.eventData.id,
      payload,
    },
    { onSuccess }
  )
}

function handleNext() {
  saveEventData(() => {
    emit('next')
  })
}

function handleCancel() {
  saveEventData(() => {
    emit('cancel')
  })
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.payment-mode {
  max-width: 410px;
  margin: 140px auto 60px;

  .form-title {
    margin-bottom: 20px;
    color: var(--color-dark-800);
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
  }

  .form-item {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-bottom: 40px;
  }

  .form-item-label {
    font-size: 16px;
    line-height: 1;
  }

  .range-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
  }

  .range-input {
    flex: 0 0 90px;
  }
}
</style>
